import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useState, useEffect } from "react";
import PrivateRoute from "./utility/PrivateRoute";
import Login from "./templates/login";
import Dashboard from "./templates/dashboard";
import Doctor from "./templates/admin/master/doctor";
import Problem from "./templates/admin/master/problem";
import Test from "./templates/admin/master/test";
import CounterRegistration from "./templates/operator/counter-registration.js";
import FollowUp from "./templates/operator/follow-up.js";
import Waiting from "./templates/doctor/waiting.js";
import PatientTests from "./templates/operator/patient-test.js";
import Signup from "./templates/signup.js";
import DailyCollectionReport from "./templates/operator/reports/DCR.js";
import DoctorWiseReport from "./templates/operator/reports/doctor-wise-report.js";
import TestWiseReport from "./templates/operator/reports/test-wise-report.js";
import CancelAppointment from "./templates/operator/cancel-appointment.js";
import Refund from "./templates/operator/refund.js";
import { initAuth } from "./utility/initAuth.js";
import EditPatientDetails from "./templates/operator/edit-patient.js";

function App() {
  window.addEventListener("error", (e) => {
    if (
      e.message ===
        "ResizeObserver loop completed with undelivered notifications." ||
      e.message === "ResizeObserver loop limit exceeded"
    ) {
      e.stopImmediatePropagation();
    }
  });

  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    async function load() {
      await initAuth(); // 🔥 Fetch a new access token at startup
      setAuthReady(true); // Continue app once token loaded
    }
    load();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/doctor-master"
          element={
            <PrivateRoute>
              <Doctor />
            </PrivateRoute>
          }
        />
        <Route
          path="/problem-master"
          element={
            <PrivateRoute>
              <Problem />
            </PrivateRoute>
          }
        />
        <Route
          path="/test-master"
          element={
            <PrivateRoute>
              <Test />
            </PrivateRoute>
          }
        />
        <Route
          path="/counter-registration"
          element={
            <PrivateRoute>
              <CounterRegistration />
            </PrivateRoute>
          }
        />
        <Route
          path="/follow-up"
          element={
            <PrivateRoute>
              <FollowUp />
            </PrivateRoute>
          }
        />
        <Route
          path="/waiting"
          element={
            <PrivateRoute>
              <Waiting />
            </PrivateRoute>
          }
        />
        <Route
          path="/daily-collection-report"
          element={
            <PrivateRoute>
              <DailyCollectionReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/doctor-wise-report"
          element={
            <PrivateRoute>
              <DoctorWiseReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/test-wise-report"
          element={
            <PrivateRoute>
              <TestWiseReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/cancel-appointment"
          element={
            <PrivateRoute>
              <CancelAppointment />
            </PrivateRoute>
          }
        />
        <Route
          path="/refund"
          element={
            <PrivateRoute>
              <Refund />
            </PrivateRoute>
          }
        />
        <Route
          path="/edit-patient-details"
          element={
            <PrivateRoute>
              <EditPatientDetails />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
